export default class Locale_ProjectListItemPercentageBar {
	NotRequestedButAllocated: string = "Not requested, but allocated";
	NotAllocatedButRequested: string = "Not allocated, but requested";
	NotAllocated: string = "Not allocated";
	Allocated: string = "Allocated";
	Category: string = "Category";
	NotRequestedAndNotAllocated: string = "Not requested, and not allocated"
}